import { type V2_MetaFunction } from '@remix-run/node'
import { GeneralErrorBoundary } from '~/components/error-boundary.tsx'
import { Container } from '~/components/Container.tsx'

export const meta: V2_MetaFunction = () => {
	return [{ title: 'About - PetCanvas' }]
}

export default function About() {
	return (
		<>
			<Container className="bg-lightGray">
				<div className="flex flex-col md:flex-row">
					<div className="w-full md:w-1/2">
						<img
							src="https://res.cloudinary.com/spark-visions/image/upload/v1682564204/about_us_cropped_mwpoy5.png"
							alt=""
						></img>
					</div>
					<div className="w-full px-16 md:w-1/2">
						<h1 id="order-heading" className="my-6 text-3xl text-gray-900">
							About Us
						</h1>
						<div>
							<p className="pb-6">
								Pet Canvas is made up of a small team of indie developers and
								artists based in Oregon. We share a love for our pets who bring
								us endless joy.
							</p>
							<p className="pb-6">
								Collectively our team has both created and shopped for a lot of
								pet art and we noticed a problem in the market. High quality pet
								art is typically hand drawn for hours and the cost is very high.
								On the other hand, businesses who produce personalized pet art
								at more affordable prices usually have to sacrifice on quality
								and care.{' '}
							</p>
							<p className="pb-6">
								We are building the best of both worlds. We offer affordable,
								high quality pet art on a growing array of styles and products.
							</p>
							<p className="pb-6">
								We’re able to do this through a hybrid approach that combines
								real artists and traditional graphic design techniques with
								AI-art software. This allows us to create emotion-inspiring,
								everlasting art of your pet that captures their unique
								personality at the speed and scale we need to keep our prices
								affordable.
							</p>
							<p className="pb-12">
								We’re always striving to get better. We value your feedback, so
								please don’t hesitate to reach out. We’d love to work with you,
								share your beautiful pet art on social media, and hear your
								funny pet stories.
							</p>
						</div>
					</div>
				</div>
			</Container>
		</>
	)
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
